import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { tomoIncludes, tomos } from '../data/content';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/76NQmyu4X2DWg45wa3VJBT/Diseno_sin_titulo_(4).png';
export function TomosSection() {
  return <section id="tomos" className="w-full bg-ink px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="tomos-title" data-id="element-257" data-mp="1u1vez4l3wtn6">
      <div className="mx-auto max-w-6xl" data-id="element-258" data-mp="11dzmkc2klnw7">
        <div className="grid items-center gap-10 rounded-[2rem] border border-gold/25 bg-surface p-6 sm:p-10 lg:grid-cols-2" data-id="element-259" data-mp="11f0zyn726mh3">
          <div className="text-center lg:text-left" data-id="element-260" data-mp="16brcj0jnmzxr">
            <p className="text-sm font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-261" data-mp="1bcfdof1lkx5p">
              🏋️ Megakit de Ingeniería Corporal
            </p>
            <h2 id="tomos-title" className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-5xl" data-id="element-262" data-mp="2hubwne0xmjly">
              Calistenia Cero Límites™
            </h2>
            <p className="mt-4 text-lg font-bold text-gold" data-id="element-263" data-mp="2mmwr75aj0r68">
              6 Tomos + 6 Bonos — Principiante → Élite
            </p>
            <p className="mt-2 text-sm text-neutral-400" data-id="element-264" data-mp="2hmhhqotd83tj">
              300+ páginas — Todo resuelto.
            </p>
            <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-265" data-mp="2cnxsaefkc9wf">
              {tomos.map(tomo => <li key={tomo.id} className="rounded-full border border-line bg-ink px-3.5 py-1.5 text-xs font-bold text-neutral-400" data-id="element-266" data-mp="27r7e5wnbjodn">
                  {tomo.label}
                </li>)}
            </ul>
          </div>
          <img src={MOCKUP_URL} alt="Contenido completo del Megakit Calistenia Cero Límites" className="mx-auto w-full max-w-md drop-shadow-[0_25px_50px_rgba(46,155,255,0.22)]" width={1024} height={1024} loading="lazy" data-id="element-267" data-mp="1tzsqvdmdp10s" />
        </div>

        <div className="mt-16" data-id="element-268" data-mp="1aeiu9l868ka6">
          <SectionHeading eyebrow="📚 6 Tomos completos" title="Principiante → Élite" data-id="element-269" data-mp="1fbj2a1okzx3x" />
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-270" data-mp="11d2mzmcnkya6">
          {tomos.map((tomo, index) => <motion.li key={tomo.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="group relative overflow-hidden rounded-2xl border border-line bg-surface p-6 transition-colors duration-200 hover:border-gold/50" data-id="element-271" data-mp="15f5yuc38i4vz" data-mpi={index}>
              <span className="absolute right-4 top-1 text-6xl font-extrabold text-white/[0.05] transition-colors group-hover:text-gold/15" aria-hidden="true" data-id="element-272" data-mp="2c102i14soqy8">
                {tomo.id}
              </span>
              <p className="relative text-xs font-extrabold uppercase tracking-[0.18em] text-gold" data-id="element-273" data-mp="5bg88i2qvpc3">
                {tomo.label}
              </p>
              <h3 className="relative mt-2 text-xl font-extrabold leading-tight tracking-tight text-white sm:text-2xl" data-id="element-274" data-mp="f3m07rszy6ra">
                {tomo.title}
              </h3>
              <p className="relative mt-3 text-sm leading-relaxed text-neutral-400" data-id="element-275" data-mp="a6c5pxqr34wl">
                {tomo.description}
              </p>
            </motion.li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-line bg-surface p-6 sm:p-8" data-id="element-276" data-mp="3dmszrsy4hbbl">
          <h3 className="text-lg font-extrabold tracking-tight text-white" data-id="element-277" data-mp="3sja96emr4fvi">
            Cada tomo incluye:
          </h3>
          <ul className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-278" data-mp="3nl8r9x12amlm">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-279" data-mp="17tkwo89it65z">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-280" data-mp="12s584684whiu" />
                <span className="text-sm text-neutral-300" data-id="element-281" data-mp="3dfqxy0ft5n39">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}